import React from "react";
import { ArrowDown, ArrowUp, Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

/* Editor list generik: tambah / hapus / naik-turun. `renderItem(item, update, index)` merender field per item. */
export function ListEditor({ items = [], onChange, max, newItem, renderItem, addLabel = "Tambah", emptyText = "Belum ada item.", testId }) {
  const update = (i, patch) => onChange(items.map((it, idx) => (idx === i ? { ...it, ...patch } : it)));
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= items.length) return;
    const next = [...items];
    [next[i], next[j]] = [next[j], next[i]];
    onChange(next);
  };
  const full = max && items.length >= max;
  return (
    <div className="space-y-3" data-testid={testId}>
      {items.length === 0 ? <p className="text-xs text-[#8A8A8A]" data-testid={`${testId}-empty`}>{emptyText}</p> : null}
      {items.map((it, i) => (
        <div key={i} className="rounded-xl border border-[#E5E5E5] p-3 sm:p-4 grid gap-3" data-testid={`${testId}-item-${i}`}>
          <div className="flex items-center justify-between gap-2">
            <span className="text-[11px] font-bold uppercase tracking-wider text-[#8A8A8A]">Item {i + 1}</span>
            <div className="flex items-center gap-1">
              <Button type="button" size="icon" variant="ghost" className="h-8 w-8" disabled={i === 0} onClick={() => move(i, -1)} aria-label="Naik" data-testid={`${testId}-up-${i}`}><ArrowUp size={14} /></Button>
              <Button type="button" size="icon" variant="ghost" className="h-8 w-8" disabled={i === items.length - 1} onClick={() => move(i, 1)} aria-label="Turun" data-testid={`${testId}-down-${i}`}><ArrowDown size={14} /></Button>
              <Button type="button" size="icon" variant="ghost" className="h-8 w-8 text-[#DC2F02]" onClick={() => remove(i)} aria-label="Hapus" data-testid={`${testId}-remove-${i}`}><Trash2 size={14} /></Button>
            </div>
          </div>
          {renderItem(it, (patch) => update(i, patch), i)}
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" disabled={full} onClick={() => onChange([...items, newItem()])} data-testid={`${testId}-add`}>
        <Plus size={14} className="mr-1" /> {addLabel}{max ? ` (${items.length}/${max})` : ""}
      </Button>
    </div>
  );
}
